import * as THREE from "three";
import { MathUtils, Vector2, Vector3 } from "three";
import { fabricColor, fabricCoverNormal, fabricNormal, } from "../../assets/materials";
import { ModelSkeleton } from "./ModelSkeleton";
import { ExtraType } from "../../../entities/LedExtras";
var degToRad = MathUtils.degToRad;
export class SilverModelSkeleton extends ModelSkeleton {
    createModule(pos, modulePlace) {
        const fabricCoverProjection = this.data.measuredModel.projection / 47 * 7 + 30;
        const moduleWidth = this.data.measuredModel.width;
        const moduleProjection = this.data.measuredModel.projection;
        const edgeWidth = this.data.measuredModel.model.edgeWidth;
        const edgeHeight = this.data.measuredModel.model.edgeHeight;
        const railCenterQty = Math.ceil(moduleWidth / 450);
        const railQty = railCenterQty + 1;
        const slopePercent = moduleWidth / railCenterQty / 25 - 1;
        const slope = slopePercent / 100 * moduleProjection;
        const slopeDegree = Math.round(Math.atan(slopePercent / 100) * 180 / Math.PI * 10000) / 10000;
        // Roof
        this.createFabricCover(slopeDegree, slope, pos, fabricCoverProjection);
        this.createFabric(slopeDegree, slope, pos);
        const railSize = new Vector3(moduleProjection + edgeWidth * 2, edgeHeight, edgeWidth);
        const frontPillarSize = new Vector3(edgeWidth, 260, edgeWidth);
        const backPillarSize = new Vector3(edgeWidth, 260 + slope + edgeHeight, edgeWidth);
        const frontBeamSize = new Vector3(moduleWidth + 20, edgeHeight, edgeWidth);
        const backBeamSize = new Vector3(moduleWidth, edgeHeight, edgeWidth);
        const sideBeamSize = new Vector3(moduleProjection, edgeHeight, edgeWidth);
        //Back beam
        this.createEdge(new Vector3(pos.x - moduleProjection / 2, pos.y + slope + edgeHeight, pos.z), backBeamSize, 90);
        // Second back beam when glass is present
        if (this.scene.formData.far.extra !== ExtraType.NONE)
            this.createEdge(new Vector3(pos.x - moduleProjection / 2, pos.y, pos.z), backBeamSize, 90);
        //Front beam
        this.createEdge(new Vector3(pos.x + moduleProjection / 2, pos.y, pos.z), frontBeamSize, 90);
        const edgeW = this.scene.formData.measuredModel.model.edgeWidth;
        //Rails & Pillars
        for (let i = 0; i < railQty; i++) {
            let adjust = 0;
            if (i === 0) {
                adjust = edgeWidth / 2;
            }
            else if (i == railQty - 1) {
                adjust = -edgeWidth / 2;
            }
            //RAILS
            const railposX = pos.x + edgeWidth / 1.5;
            const railposY = pos.y + slope / 2 + edgeHeight - 0.7;
            const railposZ = pos.z + (moduleWidth / railCenterQty * i) - moduleWidth / 2 + adjust;
            const railpos = new Vector3(railposX, railposY, railposZ);
            this.createEdge(railpos, railSize, 0, -slopeDegree);
            //FRONT PILLARS
            const frontPillarposX = pos.x + moduleProjection / 2;
            const frontPillarposY = pos.y - frontPillarSize.y / 2;
            const frontPillarposZ = pos.z + (moduleWidth / railCenterQty * i) - moduleWidth / 2 + adjust;
            const frontPillarpos = new Vector3(frontPillarposX, frontPillarposY, frontPillarposZ);
            // If there is glass we need to keep the pillars
            const rightWall = this.scene.formData.right.wall;
            const leftWall = this.scene.formData.left.wall;
            // Only create the pillars when there is no wall present
            if (i === 0 && modulePlace === 1 && rightWall === true) { }
            else if (this.data.measuredModel.modulesZ === modulePlace && i === railQty - 1 && leftWall === true) { }
            else {
                this.createEdge(frontPillarpos, frontPillarSize, 0);
            }
            // Sidebeams and projection side extra leg when it's more than 700
            if (this.data.freestanding === true || this.data.left.extra !== ExtraType.NONE) {
                // Middle projection pillar
                if (this.data.projectionValue > 700)
                    this.createEdge(new THREE.Vector3(this.scene.dimensions.left.position.x, 130, this.scene.dimensions.left.position.z), new THREE.Vector3(edgeW, 260, edgeW));
                // Left sidebeam
                this.createEdge(new Vector3(pos.x, pos.y, pos.z + moduleWidth - moduleWidth / 2 - edgeWidth / 2), sideBeamSize, 0);
            }
            if (this.data.freestanding === true || this.data.right.extra !== ExtraType.NONE) {
                // Middle projection pillar
                if (this.data.projectionValue > 700)
                    this.createEdge(new THREE.Vector3(this.scene.dimensions.right.position.x, 130, this.scene.dimensions.right.position.z), new THREE.Vector3(edgeW, 260, edgeW));
                // Right sidebeam
                this.createEdge(new Vector3(pos.x, pos.y, pos.z - moduleWidth / 2 + edgeWidth / 2), sideBeamSize, 0);
            }
            //BACK PILLARS
            if (this.data.freestanding === true) {
                const backPillarposX = pos.x - moduleProjection / 2;
                const backPillarposY = backPillarSize.y / 2;
                const backPillarposZ = pos.z + (moduleWidth / railCenterQty * i) - moduleWidth / 2 + adjust;
                const backPillarpos = new Vector3(backPillarposX, backPillarposY, backPillarposZ);
                this.createEdge(backPillarpos, backPillarSize, 0);
            }
        }
    }
    createFabricCover(slopeDegree, slope, position, fabricCoverProjection) {
        const pillarTextureRepeat = new Vector2(this.data.measuredModel.width / 1024 * 4, fabricCoverProjection / 1024 * 4);
        const fabricCoverMat = this.scene.materialPicker.getMaterial(pillarTextureRepeat, fabricCoverNormal);
        const fabricCoverGeometry = new THREE.BoxGeometry(this.data.measuredModel.width - 2, fabricCoverProjection, 2);
        const fabricCover = new THREE.Mesh(fabricCoverGeometry, fabricCoverMat);
        fabricCover.castShadow = true;
        fabricCover.position.set(0 - this.data.measuredModel.projection / 2 + fabricCoverProjection / 2, 260 + this.data.measuredModel.model.edgeHeight + slope - (slope / this.scene.formData.measuredModel.projection) * fabricCoverProjection / 2 + 3, position.z);
        fabricCover.rotateY(MathUtils.degToRad(90));
        fabricCover.rotateX(MathUtils.degToRad(90 - -slopeDegree));
        this.scene.threeScene.add(fabricCover);
    }
    createCrossRails(pos, length, slope, slopeDegree) {
        const mat = this.scene.materialPicker.getMaterial(new Vector2(length / 1024 * 24, 3 / 1024 * 24));
        const startingPos = pos.x + length / 2;
        const mesh = new THREE.InstancedMesh(new THREE.BoxGeometry(6, 3, this.scene.formData.measuredModel.width - this.scene.formData.measuredModel.model.edgeWidth * 2), mat, 6);
        const positions = [];
        const scale = new THREE.Vector3(1, 1, 1);
        const rot = new THREE.Quaternion().setFromEuler(new THREE.Euler(0, 0, degToRad(0)));
        for (let i = 1; i <= 6; i++) {
            const finalPos = new THREE.Vector3().copy(pos);
            finalPos.x = startingPos - this.scene.formData.measuredModel.projection / 6 * i;
            finalPos.y -= 4;
            mesh.setMatrixAt(i - 1, new THREE.Matrix4().compose(finalPos, rot, scale));
            positions.push(finalPos);
        }
        this.scene.pvcLedLights.createPVCLights(positions, new THREE.Color(0xFFFFFF), -slopeDegree);
        mesh.geometry.center();
        mesh.rotateZ(MathUtils.degToRad(-slopeDegree));
        this.scene.threeScene.add(mesh);
    }
    createFabric(slopeDegree, slope, position) {
        const edgeWidth = this.data.measuredModel.model.edgeWidth;
        const edgeHeight = this.data.measuredModel.model.edgeHeight;
        const fabricMat = this.scene.materialPicker.getMaterial(undefined, undefined, false, 0.2);
        let map = new THREE.Texture();
        this.scene.assignTexture(map, fabricColor);
        map.repeat = new Vector2(this.data.measuredModel.width / 1024 * 8, this.data.measuredModel.projection / 1024 * 8);
        fabricMat.map = map;
        fabricMat.normalMap = fabricNormal;
        fabricMat.roughness = 0.1;
        const pos = new THREE.Vector3(position.x + edgeWidth / 1.5, position.y + slope / 2 + edgeHeight - 0.7, position.z);
        // Cross Rails invoked from here because it is attached to the fabric irl
        this.createCrossRails(pos, this.data.measuredModel.projection + edgeWidth * 2, slope, slopeDegree);
        /*	const fabricMat = new THREE.MeshStandardMaterial({
                map: map,
                polygonOffsetFactor: -1.0,
                normalMap: fabricNormal,
            })*/
        const fabricGeometry = new THREE.BoxGeometry(this.data.measuredModel.width - edgeWidth, this.data.measuredModel.projection + edgeWidth * 2, 2);
        const mesh = new THREE.Mesh(fabricGeometry, fabricMat);
        fabricMat.metalness = 0.5;
        fabricMat.refractionRatio = 0;
        mesh.castShadow = true;
        mesh.position.set(pos.x, pos.y, pos.z);
        mesh.rotateY(MathUtils.degToRad(90));
        mesh.rotateX(MathUtils.degToRad(90 - -slopeDegree));
        this.scene.threeScene.add(mesh);
    }
}
